import React, { useContext, useEffect } from 'react';
import { get, includes } from 'lodash';

import { matchPath, useLocation } from 'react-router-dom';
import SettingsContext from '../../contexts/SettingsContext';
import PrintContext from '../../contexts/PrintContext';
import PublicContext from '../../contexts/PublicContext';
import EmployerContext from '../../contexts/EmployerContext';
import { RoutePaths } from '../../constants/RoutePaths';

const SocialIntentsLiveChat = () => {
    const { employer } = useContext(EmployerContext);
    const { systemConfiguration } = useContext(SettingsContext);
    const location = useLocation();
    const fastRatingPageMatch = matchPath(location.pathname, {
        path: RoutePaths.fastRatingPage,
        exact: true,
        strict: true,
    });
    const isPublicMode = useContext(PublicContext);
    const isPrintMode = useContext(PrintContext);
    const isChatEnabledInOffice = includes(systemConfiguration?.officesEnabledToShowSiChat, employer?.office);
    const isSiChatInFastRatingDisabled = get(employer, 'settings.isSiChatInFastRatingDisabled', false);

    useEffect(() => {
        if (
            !isPublicMode
            && !isPrintMode
            && systemConfiguration?.isSocialIntentsChatEnabled
            && isChatEnabledInOffice
            && (fastRatingPageMatch ? !isSiChatInFastRatingDisabled : true)
        ) {
            const script = document.createElement('script');
            script.setAttribute('type', 'text/javascript');
            script.setAttribute('id', 'si-script-loader');
            script.setAttribute('src', systemConfiguration.socialIntentsChatUrl || '//www.socialintents.com/api/chat/socialintents.1.3.js#2c9fa6c383edf8100183f073153c0191');
            document.head.appendChild(script);
        }
    }, [systemConfiguration]);
};

export default SocialIntentsLiveChat;
